import type { PartnersPageContent } from '@/types/pageContent';

export const DEFAULT_PARTNERS_PAGE: PartnersPageContent = {
    hero: {
        eyebrow: 'Dream Partnerships',
        title: 'Dream Partnerships for family-friendly stays and arrivals',
        description:
            'Help parents arrive to clean, safe and convenient baby equipment without adding operational stress to your team.',
    },
    intro: {
        title: 'A simple way to make family travel feel looked after',
        paragraphs: [
            'Stork Rentals helps hotels, resorts, travel planners and local family services offer premium baby equipment without carrying stock themselves.',
            'We handle preparation, delivery and customer support so your guests get a smoother experience from the moment they book.',
        ],
    },
    highlights: [
        {
            title: 'Add a reassuring family service',
            description: 'Give parents one less thing to pack and one more reason to trust your recommendation.',
        },
        {
            title: 'Keep operations light for your team',
            description: 'We manage fulfilment, cleaning and logistics so your staff can stay focused on hospitality.',
        },
        {
            title: 'Create value that feels premium',
            description: 'Offer a polished experience that strengthens loyalty, reviews and repeat family bookings.',
        },
    ],
    logoGroup: {
        title: 'Trusted by partners who welcome families every day',
        description: 'Explore the businesses already working with Stork Rentals across accommodation, travel and family support.',
    },
    inquiry: {
        title: 'Tell us about your business',
        description: 'We will shape the right partnership approach for your location, customers and operational flow.',
        bulletPoints: [
            'Flexible setups for travel and local family demand',
            'Warm onboarding with clear operational guidance',
            'A premium service aligned with family confidence',
        ],
    },
    finalCta: {
        title: 'Let’s create a calmer travel experience for parents together',
        description: 'Start the conversation and we will help you understand what partnering with Stork Rentals could look like.',
        callout: 'Clean, Safe and Convenient for every family you welcome.',
    },
};
